package br.com.vvrefeicoes.portal.core.util.file

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import org.w3c.dom.DragEvent
import org.w3c.dom.events.Event
import org.w3c.files.FileReader

@Composable
actual fun DocumentDropZone(
    onFiles: (List<PickedFile>) -> Unit,
    content: @Composable () -> Unit,
) {
    DisposableEffect(onFiles) {
        val dragOver: (Event) -> Unit = { event -> event.preventDefault() }
        val drop: (Event) -> Unit = { event ->
            event.preventDefault()
            val files = (event as? DragEvent)?.dataTransfer?.files
            if (files != null && files.length > 0) {
                val picked = mutableListOf<PickedFile>()
                var remaining = files.length
                for (index in 0 until remaining) {
                    val file = files.item(index) ?: continue
                    val reader = FileReader()
                    reader.onload = {
                        val binary = reader.result?.toString()
                        if (binary != null) {
                            picked += PickedFile(file.name, ByteArray(binary.length) { binary[it].code.toByte() }, file.type)
                            remaining--
                            if (remaining == 0) onFiles(picked)
                        }
                    }
                    reader.readAsBinaryString(file)
                }
            }
        }
        document.addEventListener("dragover", dragOver)
        document.addEventListener("drop", drop)
        onDispose {
            document.removeEventListener("dragover", dragOver)
            document.removeEventListener("drop", drop)
        }
    }
    content()
}
